// @flow
import React from 'react';
import { MessageListContainer, messageListTypes } from 'bk-web-app/message-list';
import { SidebarSection } from 'bench-internal-theme';

import { type InternalNote } from './types';

type InternalNotesProps = {
  clientId: string,
  internalNotes: Array<InternalNote>,
  journalEntryId: string,
};

const InternalNotes = ({ clientId, internalNotes, journalEntryId }: InternalNotesProps) => (
  <SidebarSection title="Internal Notes">
    <MessageListContainer
      clientId={clientId}
      listType={messageListTypes.JOURNAL_ENTRY_INTERNAL_NOTE}
      messages={internalNotes}
      parentId={journalEntryId}
      placeholder="Leave a note for your team"
      zeroStateMessage="(Currently no internal notes for journal entry.)"
    />
  </SidebarSection>
);

export default InternalNotes;
